
import { Vue, Options } from 'vue-class-component';
import MoreInfoButton from '@/components/shared/more-info-button.vue';

@Options({
  components: {
    MoreInfoButton
  },
  props: {
    itemData: {
      title: {
        type: String
      },
      price: {
        type: String
      },
      thumbnail: {
        type: String
      }
    },
    itemAdded: {
      type: Boolean
    }
  },
  data() {
    return {
      itemAdded: false
    }
  }
})
export default class MultiImageDisplayCard extends Vue {
  itemAdded: boolean;

  addItem(x: boolean) {
    this.itemAdded = x;
  }
}
